import {Component, inject, Input, OnInit} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {DatePipe, JsonPipe} from "@angular/common";
import {MaterialModule} from "../../../../material.module";
import {environment} from "../../../../../environments/environment";
import {Marked} from "marked";
import {ContentInterpreterService} from "../../../../services/content-interpreter.service";


@Component({
  selector: 'app-task-previous-runs',
  templateUrl: './task-previous-runs.component.html',
  styleUrls: ['./task-previous-runs.component.scss'],
    imports: [MaterialModule, ReactiveFormsModule, FormsModule, DatePipe, JsonPipe]
})
export class TaskPreviousRunsComponent implements OnInit {
    marked = inject(Marked);
    private contentInterpreter = inject(ContentInterpreterService);

  @Input() allTasks!: any[];

  expandedElement: any;

  displayedColumns: string[] = [ 'id', 'clientId', 'description', 'created', 'completedSuccessfully' ]

  ngOnInit(): void {

  }

  parseTextOutput(textOutput: any): string {
    if (textOutput && textOutput.base64Data && textOutput.contentType) {
      const interpretedText = this.contentInterpreter.interpretContent(
          textOutput.contentType,
          textOutput.base64Data
      );
      return typeof interpretedText === 'string' ? this.marked.parse(interpretedText) as string : '';
    } else {
      return '';
    }
  }

  parseAudioOutput(output: any): string {
    if (output && output.base64Data && output.contentType) {
      const interpretedAudio = this.contentInterpreter.interpretContent(
          output.contentType,
          output.base64Data
      );
      return typeof interpretedAudio === 'string' ? interpretedAudio : '';
    } else {
      return ""
    }
  }

  protected readonly environment = environment;
}
